
import Request from "@/module/request/request"
import Component, { ComponentMethods } from "../module/component/component"

import elemIcon from "./elem-icon.vue"

class EntityComponent extends ComponentMethods implements ComponentEntity {
    private fields: obj[] = null

    private entity: obj = null

    private show: boolean = false

    public entity_title: string = "实体"

    public entity_name: string

    props = {
        config: Object,
        name: String,
        title: {
            type: String,
            default: "实体",
        },
    }

    language = {}

    components = {
        elemIcon,
    }

    created() {
        if (this.name) {
            this.getConfig(this.name)
        }

        if (this.title) {
            this.entity_title = this.title
        }
    }

    setConfig(config: { name: string; title: string }) {
        if (config.name) {
            this.getConfig(config.name)
        }

        if (config.title) {
            this.entity_title = config.title
        }
    }

    getConfig(name: string) {
        this.entity_name = name

        Request.get<obj[]>(`ADMIN://${name}/GetEntityInfo`).then(res => {
            this.fields = res.sort(v1 => (v1.type === "Textarea" ? 1 : -1))
        })
    }

    open(uuid: string): void {
        Request.get<obj>(`ADMIN://${this.entity_name}/FindProcessEntity`, { uuid }).then(res => {
            this.entity = res
            this.show = true
        })
    }
}

export default Component.build(new EntityComponent())
